/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

#card-injury-activity {
  > div div h6 {
    width: 200px;
  }

  .row div.MuiFormGroup-root.MuiRadioGroup-root {
    align-items: flex-start;
    label {
      width: 100%;
    }
  }
}
